<script setup lang="ts">
import type { ButtonVariants } from '#ui-kit/ui/button'
import { useTemplateRef } from 'vue'
import { Button } from '#ui-kit/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '#ui-kit/ui/dialog'

const props = defineProps<{
  title: string
  confirmLabel: string
  confirmVariant: ButtonVariants['variant']
  loading?: boolean
}>()

const emit = defineEmits<{
  confirm: []
}>()

const slots = defineSlots<{
  icon: () => unknown
  default?: () => unknown
}>()

const open = defineModel<boolean>('open', { default: false })

const footer = useTemplateRef<HTMLElement>('footer')

function onOpenChange(value: boolean) {
  if (!value && props.loading) {
    return
  }
  open.value = value
}

// Start on Cancel so Enter never confirms by accident.
function focusCancel(event: Event) {
  event.preventDefault()
  footer.value?.querySelector('button')?.focus()
}
</script>

<template>
  <Dialog :open="open" @update:open="onOpenChange">
    <DialogContent :hide-close="loading" role="alertdialog" @open-auto-focus="focusCancel">
      <div class="flex flex-col gap-4 font-display">
        <div class="flex flex-col gap-2 [&>svg]:size-10">
          <slot name="icon" />
          <DialogTitle class="text-xl leading-normal tracking-normal wrap-anywhere text-primal">
            {{ title }}
          </DialogTitle>
          <DialogDescription v-if="slots.default" as="div" class="space-y-4 text-secondary">
            <slot />
          </DialogDescription>
        </div>
        <div ref="footer" class="flex gap-4 *:flex-1">
          <Button variant="outline" :disabled="loading" @click="onOpenChange(false)">Cancel</Button>
          <Button :variant="confirmVariant" :loading="loading" @click="emit('confirm')">{{ confirmLabel }}</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
